<section class="operations-shell">
    <header class="operations-shell__header">
        <div>
            <h1 class="operations-shell__title">Vision Configuration</h1>
            <p class="operations-shell__subtitle">
                Configure organization vision policies, per-camera analytics, capabilities, and provider infrastructure.
            </p>
        </div>
        <div class="operations-shell__status" *ngIf="visionConfig.snapshot as context">
            <span class="operations-shell__badge"
                  [class.operations-shell__badge--active]="visionConfig.isVisionActive">
                Vision {{ visionModeLabel(visionConfig.visionPolicy.vision_mode) }}
            </span>
            <span class="operations-shell__badge operations-shell__badge--muted"
                  *ngIf="context.vte_pipeline_enabled === false">
                Pipeline disabled
            </span>
        </div>
    </header>

    <nav class="operations-shell__nav" aria-label="Vision configuration sections">
        <a *ngFor="let item of navItems"
           class="operations-shell__nav-link"
           [routerLink]="item.path"
           routerLinkActive="operations-shell__nav-link--active"
           [routerLinkActiveOptions]="{ exact: item.exact }">
            {{ item.label }}
        </a>
    </nav>

    <router-outlet></router-outlet>
</section>
